import useMediaQuery from '@mui/material/useMediaQuery';

export const useResponsive = () => {
  const isDesktop = useMediaQuery('(min-width: 1200px)');
  const isTablette = useMediaQuery('(min-width: 768px) and (max-width: 1200px)');
  const isMobile = useMediaQuery('(max-width: 991px)');
  return { isDesktop, isTablette, isMobile };
};